import React, { Component } from 'react';
import { LandingTopBar } from './shared/topBar/landing';
import Layout from './components/layout';
import './App.scss';

class App extends Component {
  constructor() {
    super();

    this.state = {
      isEaster1: false,
      isEaster2: false,
      cityHandler: '',
      isMobile: false,
      isBackDrop: false,
      hasToken: false,
    };

    this.onEaster1 = this.onEaster1.bind(this);
    this.onEaster2 = this.onEaster2.bind(this);
    this.onSelectCity = this.onSelectCity.bind(this);
  }

  componentDidMount() {
    const windowWidth = window.innerWidth;

    if (windowWidth && windowWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }

    const token = localStorage.getItem('salom::admin::token');
    if (token && token.length > 60) {
      this.setState({
        hasToken: true,
      });
    }
  }

  onEaster1() {
    this.setState({
      isEaster1: true,
    });
  }

  onEaster2() {
    this.setState({
      isEaster2: !this.state.isEaster2,
    });
  }

  onSelectCity(event) {
    this.setState({
      cityHandler: event,
    });
  }

  handleBackDrop(event) {
    this.setState({
      isBackDrop: event,
    });
  }

  render() {
    let isEaster1 = this.state.isEaster1;
    let isEaster2 = this.state.isEaster2;

    const scrollToTopParams = {
      position: 'fixed',
      right: 'auto',
      left: 35,
      bottom: 80,
      cursor: 'pointer',
      transitionDuration: '0.2s',
      transitionTimingFunction: 'linear',
      transitionDelay: '0s',
    };

    return (
      <div>
        {this.state.isMobile ? (
          <div
            className={this.state.isBackDrop ? 'backdrop-layer' : 'layer'}
          ></div>
        ) : null}
        <div
          className={
            isEaster1
              ? 'salom-app easter1'
              : isEaster2
              ? 'salom-app easter2'
              : 'salom-app'
          }
        >
          <LandingTopBar onSelectCity={this.onSelectCity} />
          <Layout
            onEaster1={this.onEaster1}
            onEaster2={this.onEaster2}
            onSelectCityHandler={this.state.cityHandler}
          />
        </div>
      </div>
    );
  }
}

export default App;
